import { render, staticRenderFns } from "./BattleAcademiaDetail.vue?vue&type=template&id=7e21287e&"
import script from "./BattleAcademiaDetail.vue?vue&type=script&lang=js&"
export * from "./BattleAcademiaDetail.vue?vue&type=script&lang=js&"
import style0 from "./BattleAcademiaDetail.vue?vue&type=style&index=0&id=7e21287e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports